import React, { useEffect, useState } from 'react';
import { gatewayApi } from '../services/gateway';
import { HelpHint } from '../common/SafeIcon';

export default function ScheduledEmails() {
  const [rows,setRows] = useState([]);
  const [apps,setApps] = useState([]);
  const [templates,setTemplates] = useState([]);
  const [form,setForm] = useState({app_id:'',template_id:'',recipients:'',scheduled_at:''});
  const [busy,setBusy] = useState(false);
  const [error,setError] = useState('');
  const reload=async()=>{
    const [a,b,c]=await Promise.all([gatewayApi.listSchedules(),gatewayApi.listApps(),gatewayApi.listTemplates()]);
    setRows(a.data||[]);setApps(b.data||[]);setTemplates(c.data||[]);
  };
  useEffect(()=>{reload().catch(e=>setError(e.message));},[]);
  const update=(key,value)=>setForm(p=>({...p,[key]:value}));
  const create=async(e)=>{
    e.preventDefault();setError('');
    const app=apps.find(a=>a.id===form.app_id);
    if(!app){setError('Choose an application');return;}
    const recipients=form.recipients.split(/[;,\n]+/).map(x=>x.trim()).filter(Boolean);
    if(!recipients.length || recipients.length>500){setError('Enter 1 to 500 recipients');return;}
    const schedule=new Date(form.scheduled_at);
    if(!Number.isFinite(schedule.getTime()) || schedule<=new Date()){setError('Choose a future time');return;}
    setBusy(true);
    try{
      await gatewayApi.createSchedule({client_id:app.clientId,app_id:app.id,template_id:form.template_id,
        campaign_name:'Scheduled email',scheduled_at:schedule.toISOString(),status:'scheduled',recipients});
      await reload();setForm({app_id:'',template_id:'',recipients:'',scheduled_at:''});
    }catch(err){setError(err.message||'Unable to schedule email');}
    finally{setBusy(false);}
  };
  const cancel=async(row)=>{
    if(!window.confirm('Cancel this scheduled email?'))return;
    setBusy(true);
    try{
      await gatewayApi.updateSchedule({id:row.id,client_id:row.client_id,app_id:row.app_id,
        template_id:row.template_id,campaign_name:row.campaign_name,
        scheduled_at:row.scheduled_at,recipients:row.recipients,metadata:row.metadata,status:'cancelled'});
      await reload();
    }catch(err){setError(err.message);}
    finally{setBusy(false);}
  };
  return <div className="space-y-6 pb-12">
    <div><h2 className="text-2xl font-bold text-slate-900">Scheduled emails</h2>
      <p className="text-sm text-slate-500">Real PocketBase campaigns. Delivery is processed by the secured scheduled worker.</p></div>
    {error&&<p role="alert" className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-800">{error}</p>}
    <form onSubmit={create} className="rounded-2xl border bg-white p-5 space-y-4">
      <h3 className="font-semibold text-slate-900">Schedule an email</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="schedule-app">Application</label><HelpHint label="Application"/></div>
          <select id="schedule-app" required className="mt-1 w-full rounded-lg border p-2" value={form.app_id} onChange={e=>update('app_id',e.target.value)}>
            <option value="">Select application</option>{apps.map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
        </div>
        <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="schedule-template">Active template</label><HelpHint label="Active template"/></div>
          <select id="schedule-template" required className="mt-1 w-full rounded-lg border p-2" value={form.template_id} onChange={e=>update('template_id',e.target.value)}>
            <option value="">Select template</option>{templates.filter(t=>t.status==='active'&&(!t.app_id||t.app_id===form.app_id)).map(t=><option key={t.id} value={t.id}>{t.template_name}</option>)}
          </select>
        </div>
      </div>
      <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="schedule-recipients">Recipients (one per line or comma separated)</label><HelpHint label="Recipients (one per line or comma separated)"/></div>
        <textarea id="schedule-recipients" required rows="3" className="mt-1 w-full rounded-lg border p-2" value={form.recipients} onChange={e=>update('recipients',e.target.value)} placeholder="person@example.com"/>
      </div>
      <div className="text-sm"><div className="flex items-center gap-1"><label htmlFor="schedule-at">Scheduled local date and time</label><HelpHint label="Scheduled local date and time"/></div>
        <input id="schedule-at" type="datetime-local" required className="mt-1 block w-full rounded-lg border p-2" value={form.scheduled_at} onChange={e=>update('scheduled_at',e.target.value)}/>
      </div>
      <button disabled={busy} className="rounded-xl bg-blue-600 px-5 py-2.5 text-white disabled:opacity-50">{busy?'Saving…':'Schedule Email'}</button>
    </form>
    <section className="rounded-2xl border bg-white overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead><tr className="bg-slate-50 text-slate-500"><th className="p-4">Campaign</th><th className="p-4">Recipients</th><th className="p-4">Scheduled</th><th className="p-4">Status</th><th className="p-4">Action</th></tr></thead>
        <tbody>{rows.map(row=><tr key={row.id} className="border-t">
          <td className="p-4">{row.campaign_name}</td><td className="p-4">{Array.isArray(row.recipients)?row.recipients.length:0}</td>
          <td className="p-4">{row.scheduled_at}</td><td className="p-4">{row.status}</td>
          <td className="p-4"><button disabled={busy||row.status!=='scheduled'} className="text-red-700 disabled:text-slate-400" onClick={()=>cancel(row)}>Cancel</button></td>
        </tr>)}</tbody>
      </table>{!rows.length&&<p className="p-4 text-sm text-slate-500">No scheduled emails found.</p>}
    </section>
  </div>;
}